import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import produce from 'immer';

import {
  ENTITY_CONNECTIONS_CHANGED
} from 'app/_state/entity/view-entity/entity-connections/entity-connection.actions';
import { cursorSubtract } from 'helpers';

import {
  DeleteEntityConnectionGQL, EntityConnectionCoreFragment, GetEntityConnections
} from 'generated/graphql';
@Injectable({ providedIn: 'root' })
export class DeleteEntityConnectionService {

  constructor(
    private _deleteEntityConnectionGQL: DeleteEntityConnectionGQL,
    private _store: Store
  ) {
  }

  /**
   * Deletes an entity connection and performs query / cache
   * updates
   */
  deleteEntityConnection(
    campaignId: string,
    entityConnection: EntityConnectionCoreFragment
  ) {

    return this._deleteEntityConnectionGQL.mutate({
      input: {
        entityConnectionId: entityConnection.id,
        campaignId
      }
    }, {
      update: (cache, result) => {
        const deleted = result.data.deleteEntityConnection.entityConnection;

        cache.modify(
          {
            id: 'ROOT_QUERY',
            fields: {
              getEntityConnections(value: GetEntityConnections.GetEntityConnections, details) {
                const { toReference } = details;
                const deletedRef = toReference(deleted).__ref;
                const nodeIdentifiers = value.nodes.map(n => toReference(n).__ref);
                const hasNode = nodeIdentifiers.includes(deletedRef);
                if (!hasNode) {
                  return value;
                }

                const nextState = produce(value, (draftState) => {
                  const newNodes = value.nodes.filter(n => toReference(n).__ref !== deletedRef);
                  draftState.nodes = newNodes;
                  draftState.pageInfo.endCursor = cursorSubtract(value.pageInfo.endCursor, 1);
                  draftState.totalCount = value.totalCount - 1;
                  draftState.pageInfo.hasNextPage = draftState.totalCount > newNodes.length;
                });

                return nextState;
              }
            }
          }
        );

        cache.evict({
          id: cache.identify(deleted)
        });
      }
    }).pipe(
      tap((res) => {
        this._store.dispatch(
          ENTITY_CONNECTIONS_CHANGED({
            payload: {
              entityConnection: res.data.deleteEntityConnection.entityConnection
            }
          })
        );
      })
    );
  }
}
